import { useSelector } from 'react-redux';
import { Button, Cell, DeprecatedIcon, Spacer, Text } from '@vinted/web-ui';
import SeparatedList from 'components/SeparatedList';
import useTranslate from 'hooks/useTranslate';
import { getLocale } from 'state/intl/selectors';
import { formatCurrencyAmount } from 'libs/utils/formatString';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";

const OrderSummary = _ref => {
  let {
    order,
    onShowSalesTaxModal
  } = _ref;
  const translate = useTranslate('closet_promotion.order_confirmation_modal.order_summary');
  const locale = useSelector(getLocale);
  const {
    salesTax,
    total,
    isTaxCovered,
    payable,
    effectiveDays,
    discount,
    discountPercentage
  } = order;

  function renderPrice() {
    const dayCount = translate('price_day_count', {
      count: effectiveDays
    }, {
      count: effectiveDays
    });
    return /*#__PURE__*/_jsx(Cell, {
      styling: Cell.Styling.Tight,
      suffix: formatCurrencyAmount(total, locale),
      children: /*#__PURE__*/_jsx(Text, {
        text: "".concat(translate('price'), " ").concat(dayCount)
      })
    });
  }

  function renderDiscount() {
    if (parseFloat(order.discount.amount) <= 0) return null;
    return /*#__PURE__*/_jsx(Cell, {
      styling: Cell.Styling.Tight,
      suffix: formatCurrencyAmount(discount, locale, {
        formatAsNegative: true
      }),
      children: /*#__PURE__*/_jsx(Text, {
        theme: "success",
        text: translate('discount', {
          percentage: discountPercentage
        })
      })
    });
  }

  function renderSalesTax() {
    if (!(salesTax !== null && salesTax !== void 0 && salesTax.amount)) return null;
    return /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(Spacer, {
        size: Spacer.Size.XLarge
      }), /*#__PURE__*/_jsx(Cell, {
        styling: Cell.Styling.Tight,
        suffix: "".concat(formatCurrencyAmount(salesTax, locale)),
        testId: "closet-promotion-order-summary-sales-tax",
        children: /*#__PURE__*/_jsxs("div", {
          className: "u-flexbox u-align-items-center",
          children: [/*#__PURE__*/_jsx(Text, {
            text: translate('sales_tax'),
            testId: "closet-promotion-order-summary-sales-tax--title"
          }), /*#__PURE__*/_jsx(Button, {
            deprecatedIcon: /*#__PURE__*/_jsx(DeprecatedIcon, {
              name: "info-circle",
              size: DeprecatedIcon.Size.Small,
              color: DeprecatedIcon.Color.GreyscaleLevel3,
              aria: {
                'aria-label': translate('a11y.sales_tax_info')
              }
            }),
            inline: true,
            size: Button.Size.Small,
            styling: Button.Styling.Flat,
            onClick: onShowSalesTaxModal,
            testId: "closet-promotion-order-summary-sales-tax--info-circle"
          })]
        })
      }), isTaxCovered && /*#__PURE__*/_jsx(Cell, {
        styling: Cell.Styling.Tight,
        body: /*#__PURE__*/_jsx(Text, {
          text: translate('sales_tax_covered_by_vinted'),
          highlightTheme: "amplified",
          type: Text.Type.Subtitle,
          testId: "closet-promotion-order-summary-sales-tax--covered-by-vinted"
        })
      })]
    });
  }

  function renderTotal() {
    return /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(Spacer, {
        size: Spacer.Size.XLarge
      }), /*#__PURE__*/_jsx(Cell, {
        styling: Cell.Styling.Tight,
        title: translate('total'),
        suffix: /*#__PURE__*/_jsx(Text, {
          type: Text.Type.Title,
          text: formatCurrencyAmount(payable, locale)
        })
      })]
    });
  }

  return /*#__PURE__*/_jsxs(Cell, {
    children: [/*#__PURE__*/_jsxs(SeparatedList, {
      separator: /*#__PURE__*/_jsx(Spacer, {
        size: Spacer.Size.Small
      }),
      children: [renderPrice(), renderDiscount()]
    }), renderSalesTax(), renderTotal()]
  });
};

export default OrderSummary;